module.exports = __webpack_public_path__ + "static/media/08_hero_mobile.553b1517.jpg";